import { Link as GatsbyLink } from 'gatsby'
import { Text } from '@chakra-ui/react'
import * as React from 'react'

import { isPageType } from '../../context/LayoutContext'

type LinkProps = React.ComponentPropsWithoutRef<typeof GatsbyLink> & {}

const Link: React.FC<LinkProps> = ({ to, children, ...others }) => {
  const internal = to ? isPageType(to) : false

  return to && to !== '' ? (
    internal ? (
      <GatsbyLink to={to} {...others}>
        {children}
      </GatsbyLink>
    ) : (
      <Text as="a" href={to} target="_blank">
        {children}
      </Text>
    )
  ) : (
    <>{children}</>
  )
}

export default Link
